import {saveHistory} from "./utils/history";
import {getUrlParameter, removeParamFromUrl} from "./utils/urlUtils";

$(document).ready(function () {
    if (typeof lightbox !== 'undefined') {
        lightbox.option({
            'resizeDuration': 0,
            'albumLabel': '%1 / %2',
            'fadeDuration': 0,
            'imageFadeDuration': 0,
        })
    }

    setInterval(function () {
        $(".alert.alert-dismissible").alert('close');
    }, 6000);

    $(".media-item-delete__button").click(function () {
        var input = $(this).parent().find("input[type='checkbox']");
        var value = $(this).closest(".card").find("input[type='text']").val();

        if ($(this).hasClass("pressed")) {
            input.prop('checked', false);
            input.val("");
            $(this).text('Smazat');
            $(this).removeClass("pressed");
            $(this).closest(".card").css("opacity", 1);
        } else {
            input.val(value);
            input.prop('checked', true);
            $(this).text('Zpět');
            $(this).addClass("pressed");
            $(this).closest(".card").css("opacity", .3);
        }
    });

    $(".video-item-delete__button").click(function () {
        if ($(this).hasClass("pressed")) {
            $(this).closest('.card').removeClass("remove-before-submit").css("opacity", 1);
            $(this).text('Smazat');
            $(this).removeClass("pressed");
        } else {
            $(this).text('Zpět');
            $(this).addClass("pressed");
            $(this).closest('.card').addClass("remove-before-submit").css("opacity", .3);
        }
    });

    $('.add-another-collection-widget').click(function (e) {
        var list = $($(this).attr('data-list-selector'));
        // Try to find the counter of the list or use the length of the list
        var counter = list.data('widget-counter') || list.children().length;

        // grab the prototype template
        var newWidget = list.attr('data-prototype');
        // replace the "__name__" used in the id and name of the prototype
        // with a number that's unique to your emails
        // end name attribute looks like name="contact[emails][2]"
        newWidget = newWidget.replace(/__name__/g, counter);
        // Increase the counter
        counter++;
        // And store it, the length cannot be used if deleting widgets is allowed
        list.data('widget-counter', counter);

        // create a new list element and add it to the list
        var newElem = $(list.attr('data-widget-tags')).html(newWidget);
        newElem.appendTo(list);
    });
});

function initPasswordInputs(){
    let inputs = document.querySelectorAll(".password-input");
    if(inputs && inputs.length > 0) {
        for(let i = 0; i < inputs.length; i++) {
            let input = inputs[i];

            let trigger = document.createElement("i");
            trigger.classList.add("bi");
            trigger.classList.add("bi-eye");
            trigger.classList.add("password-input-trigger");

            if(input.value.length < 1) {
                trigger.style.opacity = "0.5";
            }

            trigger.addEventListener("click", function(e) {
                if (e.target.previousSibling.type === "password") {
                    e.target.previousSibling.type = "text";
                } else {
                    e.target.previousSibling.type = "password";
                }
            });

            input.addEventListener("input", function(e) {
                if(e.target.value.length > 0) {
                    trigger.style.opacity = "1";
                } else {
                    trigger.style.opacity = "0.5";
                }
            })

            input.parentNode.insertBefore(trigger, input.nextSibling);
        }
    }
}

function removeTempGetParams() {

    let switch_locale = getUrlParameter("switch_locale");

    if(switch_locale) {
        console.log("sending");
        fetch("/api/locale/" + switch_locale, {
            method: "POST"
        }).then(r => r.json()).then(data => {
            console.log(data);
        })

        removeParamFromUrl("switch_locale");
    }

}

initPasswordInputs();

saveHistory();

removeTempGetParams();
